import { FC } from "react";
import {
  faAngleDown,
  faAngleUp,
  faSquareJ,
  faSquareK,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ActionIcon, Group, Tooltip } from "@mantine/core";
import { useHotkeys } from "@mantine/hooks";

interface NextPreviousButtonsProps {
  onNext: () => void;
  onPrevious: () => void;
  previousDisabled: boolean;
  nextDisabled: boolean;
  nextTooltip?: string;
  previousTooltip?: string;
  enableHotkeys?: boolean;
}
export const NextPreviousButtons: FC<NextPreviousButtonsProps> = ({
  onNext,
  onPrevious,
  nextDisabled,
  previousDisabled,
  nextTooltip,
  previousTooltip,
  enableHotkeys = true,
}) => {
  const previousHotkey = () => {
    // only allow hotkey to work if the tooltip label exists and the button is not disabled
    if (enableHotkeys && !previousDisabled) {
      // console.log("Previous finding");
      onPrevious();
    }
  };

  const nextHotkey = () => {
    // only allow hotkey to work if the tooltip label exists and the button is not disabled
    if (enableHotkeys && !nextDisabled) {
      // console.log("Next finding");
      onNext();
    }
  };

  // remove the console logs later
  useHotkeys([
    ["J", () => previousHotkey()],
    ["ArrowLeft", () => previousHotkey()],
    ["K", () => nextHotkey()], // hidden hotkey
    ["ArrowRight", () => nextHotkey()], // hidden hotkey
  ]);

  return (
    <Group gap={8}>
      <Tooltip
        label={
          <>
            {previousTooltip} <FontAwesomeIcon icon={faSquareJ} />
          </>
        }
        disabled={!previousTooltip}
        withinPortal
      >
        <ActionIcon
          onClick={onPrevious}
          variant="outline"
          c="blue"
          disabled={previousDisabled}
          radius="xs"
          fz={14}
        >
          <FontAwesomeIcon icon={faAngleUp} />
        </ActionIcon>
      </Tooltip>

      <Tooltip
        label={
          <>
            {nextTooltip} <FontAwesomeIcon icon={faSquareK} />
          </>
        }
        disabled={!nextTooltip}
        withinPortal
      >
        <ActionIcon
          onClick={onNext}
          variant="outline"
          c="blue"
          disabled={nextDisabled}
          radius="xs"
          fz={14}
        >
          <FontAwesomeIcon icon={faAngleDown} />
        </ActionIcon>
      </Tooltip>
    </Group>
  );
};
